module.exports = __webpack_public_path__ + "img/fail.82540fd0.svg";